import styled from 'styled-components';

export const DataStyle = styled.div``;
